import { render } from "./success.vue?vue&type=template&id=28d868db&scoped=true&ts=true"
import script from "./success.vue?vue&type=script&lang=ts"
export * from "./success.vue?vue&type=script&lang=ts"

import "./success.vue?vue&type=style&index=0&id=28d868db&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/nonbid_zlysz_com_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d868db"]])

export default __exports__